// extracted by mini-css-extract-plugin
export var cardWrapper = "_53-0";